import React from 'react';
import cn from 'bem-cn';

import { Stack } from '../Stack';
import { Icon } from '../Icon';

import { LikesCounterProps } from './LikesCounter.types';
import './LikesCounter.scss';

const b = cn('likes');
const defaultDirection = 'row';

export const LikesCounter = (props: LikesCounterProps) => {
    const { likes, isLiked, direction = defaultDirection, onClick } = props;

    const handleClick = () => {
        onClick?.();
    };

    return (
        <div className={b('wrapper')} onClick={handleClick}>
            <Stack direction={direction} alignItems="center" justifyContent="center" className={b()}>
                <span className={b('counter')}>{likes || 0}</span>
                <Icon
                    className={b('icon')}
                    name={isLiked ? 'heartFilled' : 'heart'}
                    fillColor={isLiked ? '#f55' : '#1e1e1e'}
                />
            </Stack>
        </div>
    );
};
